import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { axiosInstance } from '../../axios/interceptor'

export const getAllSupervisorNotesByCleanerId = createAsyncThunk('supervisor-notes/all', async (params, { rejectWithValue }) => {
  try {
    const response = await axiosInstance.get(`supervisor-notes`, { params })
    return response
  } catch (error) {
    return rejectWithValue(error)
  }
})

export const addSupervisorNote = createAsyncThunk('supervisor-notes/add', async (data, { rejectWithValue }) => {
  try {
    const response = await axiosInstance.post(`supervisor-notes`, data)
    return response
  } catch (error) {
    return rejectWithValue(error)
  }
})

export const deleteSupervisorNote = createAsyncThunk('supervisor-notes/delete', async (id, { rejectWithValue }) => {
  try {
    const response = await axiosInstance.delete(`/supervisor-notes/${id}`)
    return response
  } catch (error) {
    return rejectWithValue(error)
  }
})

export const editSupervisorNote = createAsyncThunk('supervisor-notes/edit', async (data, { rejectWithValue }) => {
  try {
    const response = await axiosInstance.put(`/supervisor-notes/${data?.id}`, data?.data)
    return response
  } catch (error) {
    return rejectWithValue(error)
  }
})

export const getSupervisorNoteID = createAsyncThunk('supervisor-notes/get/byId', async (id, { rejectWithValue }) => {
  try {
    const response = await axiosInstance.get(`/supervisor-notes/${id}`)
    return response
  } catch (error) {
    return rejectWithValue(error)
  }
})

const initialState = {
  isLoading: false,
  notesData: [],
  noteInfo: null,
  error: null
}

const SupervisorSlice = createSlice({
  name: 'notes',
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(getAllSupervisorNotesByCleanerId.pending, (state) => {
        state.isLoading = true
      })
      .addCase(getAllSupervisorNotesByCleanerId.fulfilled, (state, action) => {
        state.isLoading = false
        state.notesData = action.payload?.data?.data
      })
      .addCase(getAllSupervisorNotesByCleanerId.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.error.message
      })
      .addCase(addSupervisorNote.pending, (state) => {
        state.isLoading = true
      })
      .addCase(addSupervisorNote.fulfilled, (state) => {
        state.isLoading = false
      })
      .addCase(addSupervisorNote.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.error.message
      })
      .addCase(deleteSupervisorNote.pending, (state) => {
        state.isLoading = true
      })
      .addCase(deleteSupervisorNote.fulfilled, (state) => {
        state.isLoading = false
      })
      .addCase(deleteSupervisorNote.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.error.message
      })
      .addCase(editSupervisorNote.pending, (state) => {
        state.isLoading = true
      })
      .addCase(editSupervisorNote.fulfilled, (state) => {
        state.isLoading = false
      })
      .addCase(editSupervisorNote.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.error.message
      })
      .addCase(getSupervisorNoteID.pending, (state) => {
        state.isLoading = true
      })
      .addCase(getSupervisorNoteID.fulfilled, (state, action) => {
        state.isLoading = false
        state.noteInfo = action.payload?.data?.data
      })
      .addCase(getSupervisorNoteID.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.error.message
      })
  }
})

export default SupervisorSlice.reducer
